import { Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { FileService } from '../../../core/service/file.service';
import { FormControlExFactory } from '../../service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent {
  constructor(
    protected fb: FormBuilder,
    protected fc: FormControlExFactory,
    private _fileService: FileService
  ) {}
  // Accept AbstractControl for template binding; used internally as a FormArray.
  private _forms: FormArray;
  @Input() set forms(value: AbstractControl) {
    this._forms = value as FormArray;
  }
  get forms(): FormArray {
    return this._forms;
  }
  @Input() maxFiles = 5;
  @Input() text = 'COMMON.ATTACH_FILE';
  @Input() icon = 'file';
  @Input() buttonSize: 'extra-small' | 'small' | 'medium' = 'medium';
  @Input() buttonVariant: 'primary' | 'secondary' = 'secondary';
  @Input() allowedMimeTypes: string[] = [];
  @ViewChild('uploadFile') uploadFileElement: ElementRef;
  fileCount = 0;

  delete(form: FormGroup) {
    this.forms.controls.splice(this.forms.controls.indexOf(form), 1);
    this.fileCount--;
  }

  @Input() externalClickEvent: Observable<void>;
  private eventsSubscription: Subscription;
  showAddButton: boolean = true;

  ngOnInit() {
    if (this.externalClickEvent) {
      this.eventsSubscription = this.externalClickEvent.subscribe(() => this.uploadFileElement.nativeElement.click());
      this.showAddButton = false;
    }
  }

  ngOnDestroy() {
    if (this.eventsSubscription) this.eventsSubscription.unsubscribe();
  }

  private fileIsValid(file: File): boolean {
    if (this._fileService.validateDocument(file) !== null) {
      return false;
    }
    if (this.allowedMimeTypes && this.allowedMimeTypes.length > 0) {
      return this.allowedMimeTypes.includes(file.type);
    }
    return true;
  }

  onFileChange(files: FileList) {
    if (files && files.length === 1) {
      let file = files[0];
      if (this.fileIsValid(file)) {
        this.forms.controls.push(
          this.fb.group({
            data: this.fc.createHidden(file),
            caption: this.fc.createMandatory('COMMON.DOCUMENT', file.name),
          })
        );
        this.fileCount++;
        this.forms.markAsDirty();
      }
    }
  }
}
